import Button from "../../../../components/button/Button";
import { ReactComponent as DigitalTwinIcon } from "../../../../assets/images/doll_front.svg";
import useTranslation from "../../../../hooks/i18n/useTranslation";
import "./digitalTwinPlaceholder.css";

const DigitalTwinPlacheholder = ({ OnNewDigitalTwinClick = () => {} }) => {
  const { t } = useTranslation();
  
  const renderContent = () => {
    return (
      <div className="DigitalTwinPlaceholder-wrapper">
        <DigitalTwinIcon className="DigitalTwinPlaceholder-icon" />
        <div className="Text-area">
          {/* add translation for "Digital Twin" */}
          <div className="Main-text ">{t("196")}</div>
          {/* add translation for "Select Data To Generate" */}
          <div className="Sub-text">{t("193")}</div>
          {/* add translation for "New Digital Twin" button */}
          <Button value={t("194")} onClick={OnNewDigitalTwinClick} />
        </div>
      </div>
    );
  };

  return (
    <div className="DigitalTwinPlaceholder-container">
      <div className="DigitalTwinPlaceholder-header">
        <div className="DigitalTwinPlaceholder-title App-title-widgets">
          {/* add translation for "Digital Twin" title */}
          {t("196")}
        </div>
      </div>
      <div className="DigitalTwinPlaceholder-content">{renderContent()}</div>
    </div>
  );
};
export default DigitalTwinPlacheholder;
